'use strict';

import React, { Component } from 'react';
import Moment from "moment";
import { TableRow, TableCell, TableHead, TableBody } from '@material-ui/core';
import { MiniCard } from '../../../commonModules/layouts/CardPage';
import { MonetizationOnRounded } from '@material-ui/icons';
import { TableLayout } from '../Stock/containers/Layout';

class ProfileUserSpentList extends Component{
    state = {
            //Information
            paygoSpentList: [],
    }

    componentDidMount = async () =>  {
        var url = "/money/spent/resume?boxAssoId=" + this.props.boxAssoId;
        try {
            let req = await fetch(url,{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
       
            })
            const res = await req.json()
            console.log({res});
            
            if(res.error === "OK"){

                this.setState({paygoSpentList: res.List});
            } else {
                // this.notif("danger", res.content, "Erreur")
                console.log("[ERROR] handleSubmitCustom ", res.error);
            }
        } catch (error) {
            // this.notif("danger", error, "Erreur")
            console.log('====================================');
            console.log("[ERROR] handleSubmitCustom ", error);
            console.log('====================================');
        }
    }
    FormatDate(val){
        return Moment(val).format('YYYY-MM-DD HH:mm');
    }
    render() {
        var rowsPaygoPayment = [];
        console.log(this.state.paygoSpentList);
        this.state.paygoSpentList.sort(function(a, b) {
            a = new Date(a.timeAction);
            b = new Date(b.timeAction);
            if (a>b){
              return -1;
            }
            if (a < b){
              return 1;
            }
            return 0;
        });
        this.state.paygoSpentList.forEach(function(paymentInfo) {
            rowsPaygoPayment.push(
                <TableRow className={paymentInfo.classN}>
                    <TableCell>{this.FormatDate(paymentInfo.timeAction)}</TableCell>
                    <TableCell>{paymentInfo.amount}</TableCell>
                    <TableCell>{paymentInfo.action}</TableCell>
                    <TableCell>{paymentInfo.actionStatus}</TableCell>
                    <TableCell>{paymentInfo.paymentDate}</TableCell>
                    <TableCell>{paymentInfo.extraInfo}</TableCell>
                </TableRow>
            );
        }.bind(this));
        return (
            <MiniCard
                title="Liste des dépenses"
                avatar={<MonetizationOnRounded />}
            >
                <TableLayout>
                    <TableHead>
                        <TableRow>
                            <TableCell component="th">Date</TableCell>
                            <TableCell component="th">Montant</TableCell>
                            <TableCell component="th">Prestation</TableCell>
                            <TableCell component="th">Payé</TableCell>
                            <TableCell component="th">Date Paiement</TableCell>
                            <TableCell component="th">Extra Info</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rowsPaygoPayment}
                    </TableBody>
                </TableLayout>
            </MiniCard>
        )
    }
};
export default ProfileUserSpentList
